import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="bg-warm-white py-12 md:py-16 px-4" data-id="element-70">
      <div className="max-w-4xl mx-auto" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-display italic text-emerald-deep mb-8 font-medium" data-id="element-73">
            "Pensé que estar cansada y pesada era parte de la edad..."
          </h2>

          <p className="text-lg md:text-xl text-gray-700 font-body leading-relaxed max-w-3xl mx-auto" data-id="element-74">
            <strong className="text-emerald-dark" data-id="element-75">
              No es tu edad. Es Inflamación Sistémica.
            </strong>{' '}
            Un incendio silencioso causado por microorganismos y saboteadores en
            tu comida que:
          </p>
        </motion.div>

        <div className="space-y-4 max-w-3xl mx-auto" data-id="element-76">
          {[{
          title: 'Secuestran tu enfoque:',
          desc: 'Esa neblina mental que no te deja rendir al 100%.'
        }, {
          title: 'Drenan tu vitalidad:',
          desc: 'Despertar agotada incluso tras dormir 8 horas.'
        }, {
          title: 'Deforman tu vientre:',
          desc: 'Hinchazón que empeora después de las 4 PM.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-start bg-white p-5 rounded-xl shadow-sm border border-warm-gray" data-id="element-77">
              <XCircle className="w-6 h-6 text-red-500 mt-1 flex-shrink-0 mr-4" data-id="element-78" />
              <div data-id="element-79">
                <h3 className="text-xl font-display font-bold text-emerald-deep mb-1" data-id="element-80">
                  {item.title}
                </h3>
                <p className="text-gray-600 font-body" data-id="element-81">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}